// extracted by mini-css-extract-plugin
export var activeFilterButton = "_md-c";
export var backButton = "_md-4";
export var backIcon = "_md-5";
export var chevronShortcut = "_md-6";
export var container = "_md-1";
export var editor = "_md-8";
export var editorWrapper = "_md-7";
export var prefix = "_md-2";
export var searchIcon = "_md-3";
export var suffix = "_md-9";
export var suffixContent = "_md-a";
export var suffixText = "_md-b";
export var wrapper = "_md-0";